import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  // getTariffData,
  logIn,
  getUserData,
  logInWithGoogle,
  logOut,
  refreshUser,
  resetPasswordWithEmail,
  updateUserAvatar,
  updateUserData,
  // validateEmail,
  changePassword,
  changeSelectedService,
  finalizeLogin,
  // register,
} from "./operations.js";
import { getAllServices } from "../service/operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  {
    state.isLoading = false;
    state.error = action.payload;
  }
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState.auth,
  reducers: {
    setSelectedServiceId: (state, action) => {
      state.userData.selectedServiceId = action.payload;
    },
    setAllowRegistrationForm(state, action) {
      state.allowRegistrationForm = action.payload;
    },
  },
  extraReducers: builder =>
    builder

      //User login +
      .addCase(logIn.pending, handlePending)
      .addCase(logIn.fulfilled, (state, action) => {
        console.log("logInFulfilledPayload", action.payload);
        state.isLoading = false;
        // state.isLoggedIn = true;

        // state.accessToken = action.payload.access_token;
        // state.refreshToken = action.payload.refresh_token;
      })
      .addCase(logIn.rejected, handleRejected)

      // Login with Google +
      .addCase(logInWithGoogle.pending, (state, action) => {
        state.isLoading = true;
        state.GoogleError = null;
      })
      .addCase(logInWithGoogle.fulfilled, (state, action) => {
        state.isLoading = false;

        // state.accessToken = action.payload.access_token;
        // state.refreshToken = action.payload.refresh_token;

        // Оновлюємо userData повністю
        // state.userData = {
        //   name: action.meta.arg.displayName,
        //   email: action.meta.arg.email,
        // };

        // state.isLoggedIn = true;
      })
      .addCase(logInWithGoogle.rejected, (state, action) => {
        state.isLoading = false;
        state.GoogleError = action.payload;
      })

      .addCase(finalizeLogin.fulfilled, (state, action) => {
        state.isLoggedIn = true;

        state.accessToken = action.payload.accessToken;

        state.refreshToken = action.payload.refreshToken;
      })

      // User logout +
      .addCase(logOut.pending, handlePending)
      .addCase(logOut.fulfilled, state => {
        return { ...initialState.auth, isLoggedIn: false };
      })
      .addCase(logOut.rejected, handleRejected)

      // Refresh +
      .addCase(refreshUser.pending, state => {
        state.isRefreshing = true;
        state.isLoading = true;
        state.error = null;
      })

      .addCase(refreshUser.fulfilled, (state, action) => {
        // Отримуємо дані з persist:authSlice
        const persistedAuthSlice = JSON.parse(
          localStorage.getItem("persist:authSlice")
        );
        const storedUserData = persistedAuthSlice?.userData
          ? JSON.parse(persistedAuthSlice.userData)
          : null;
        const storedServiceId = storedUserData?.selectedServiceId;
        console.log("storedServiceId", storedServiceId);

        // Якщо є selectedServiceId в локальному сховищі, використовуємо його
        if (storedServiceId) {
          state.userData.selectedServiceId = storedServiceId;
        }
        state.isLoading = false;
        state.isRefreshing = false;
        state.isLoggedIn = true;

        state.accessToken = action.payload.access_token;
        state.refreshToken = action.payload.refresh_token;
        state.userData = {
          ...state.userData,
          ...action.payload.user,
        };
      })

      .addCase(refreshUser.rejected, (state, action) => {
        state.isRefreshing = false;
        state.isLoading = false;
        state.isLoggedIn = false;

        state.accessToken = null;
        state.refreshToken = null;
        state.userData = null;

        state.error = action.payload;
      })

      // Reset Password with email +
      .addCase(resetPasswordWithEmail.pending, state => {
        state.isLoading = true;
        state.isLoggedIn = false;
      })
      .addCase(resetPasswordWithEmail.fulfilled, state => {
        state.isLoading = false;
        state.isLoggedIn = false;
      })
      .addCase(resetPasswordWithEmail.rejected, state => {
        state.isLoading = false;
        state.isLoggedIn = false;
      })

      // ! USER
      //Get user data +
      .addCase(getUserData.pending, handlePending)
      .addCase(getUserData.fulfilled, (state, action) => {
        // Отримуємо дані з persist:authSlice
        const persistedAuthSlice = JSON.parse(
          localStorage.getItem("persist:authSlice")
        );
        const storedUserData = persistedAuthSlice?.userData
          ? JSON.parse(persistedAuthSlice.userData)
          : null;

        // Якщо є selectedServiceId в локальному сховищі, використовуємо його
        state.userData = {
          ...action.payload,
          selectedServiceId: action.payload.current_workshop ?? null,
          // selectedServiceId: storedServiceId ?? null,
        };
        state.isLoading = false;
      })
      .addCase(getUserData.rejected, handleRejected)

      .addCase(updateUserAvatar.pending, handlePending)
      .addCase(updateUserAvatar.fulfilled, (state, action) => {
        state.userData.avatar_url = action.payload.url;
        state.isLoading = false;
      })
      .addCase(updateUserAvatar.rejected, handleRejected)

      // Update user data +
      .addCase(updateUserData.pending, handlePending)
      .addCase(updateUserData.fulfilled, (state, action) => {
        state.userData = {
          ...state.userData,
          ...action.payload.data,
        };
        state.isLoading = false;
      })
      .addCase(updateUserData.rejected, handleRejected)

      // Change password +
      .addCase(changePassword.pending, handlePending)
      .addCase(changePassword.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(changePassword.rejected, handleRejected)

      // ! CHANGE SERVICE
      .addCase(changeSelectedService.pending, handlePending)
      .addCase(changeSelectedService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accessToken = action.payload.access_token;
        state.refreshToken = action.payload.refresh_token;
      })
      .addCase(changeSelectedService.rejected, handleRejected),
});

export const {
  setSelectedServiceId,
  setAllowRegistrationForm,
} = authSlice.actions;

export default authSlice.reducer;
